import { HsHypersceneConstants } from '../../math-new/constants/hyperscene-constants.global';
import { HsVector3 } from '../../math-new/objects/vector3.class';
import type { HsHypersceneTypes } from '../../math-new/types/hyperscene-types.type';
import { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';

/**
 * Handles s generate sphere geometry data.
 * @param quality quality.
 * @returns Result value.
 */
export function hsGenerateSphereGeometryData(quality: number = 12, part: number = 1): HsRegularGeometryData {
  const vertices: number[] = [];
  const normals: number[] = [];
  for (let j: number = 0; j < quality * part; j++) {
    const angleY0: number = j / quality;
    const angleY1: number = (j + 1) / quality;
    const y0: number = Math.cos(angleY0 * Math.PI);
    const y1: number = Math.cos(angleY1 * Math.PI);
    const d0: number = Math.sin(angleY0 * Math.PI);
    const d1: number = Math.sin(angleY1 * Math.PI);
    for (let i: number = 0; i < quality; i++) {
      const angle0: number = (i / quality) * HsHypersceneConstants.PI_MUL_2;
      const angle1: number = ((i + 1) / quality) * HsHypersceneConstants.PI_MUL_2;
      const x0: number = Math.cos(angle0);
      const x1: number = Math.cos(angle1);
      const z0: number = Math.sin(angle0);
      const z1: number = Math.sin(angle1);
      const v0: HsHypersceneTypes.Array3 = [x0 * d0, y0, z0 * d0];
      const v1: HsHypersceneTypes.Array3 = [x1 * d0, y0, z1 * d0];
      const v2: HsHypersceneTypes.Array3 = [x1 * d1, y1, z1 * d1];
      const v3: HsHypersceneTypes.Array3 = [x0 * d0, y0, z0 * d0];
      const v4: HsHypersceneTypes.Array3 = [x1 * d1, y1, z1 * d1];
      const v5: HsHypersceneTypes.Array3 = [x0 * d1, y1, z0 * d1];
      vertices.push(...v1, ...v0, ...v2, ...v4, ...v3, ...v5);
      const normal: HsVector3 = new HsVector3(...v1).normalize();
      normals.push(...normal.values);
      normal.set(...v0).normalize();
      normals.push(...normal.values);
      normal.set(...v2).normalize();
      normals.push(...normal.values);
      normal.set(...v4).normalize();
      normals.push(...normal.values);
      normal.set(...v3).normalize();
      normals.push(...normal.values);
      normal.set(...v5).normalize();
      normals.push(...normal.values);
    }
  }
  return new HsRegularGeometryData(vertices, normals);
}
